import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCmsBlock } from 'lib/core/data/cms/cmsBlock/selectors'
import { EMPTY_STRING } from 'lib/core/resources/constants'
import { fetchCmsBlock } from 'lib/core/data/cms/cmsBlock'

interface useCmsBlockParams {
  id: string
  isLazy?: boolean
}

interface useCmsBlockType {
  id: string
  updatedAt?: number
  content: string
  isSuccess: boolean
  isFailure: boolean
  isFirstLoad: boolean
  isLoading: boolean
}

export const useCmsBlock = ({ id, isLazy = true }: useCmsBlockParams): useCmsBlockType => {
  const dispatch = useDispatch()
  const cmsBlock = useSelector(getCmsBlock(id))

  useEffect(() => {
    if (isLazy) {
      dispatch(fetchCmsBlock(id))
    }
  }, [
    id,
    isLazy,
    dispatch
  ])

  const { isSuccess, isFailure, updatedAt, payload } = cmsBlock || {}
  const content = payload?.content ?? EMPTY_STRING
  const isLoading = !cmsBlock && !isSuccess && !isFailure

  return {
    id,
    updatedAt,
    content,
    isSuccess,
    isFailure,
    isLoading,
    isFirstLoad: isLoading
  }
}
